
















import { Component, Vue } from 'vue-property-decorator'
import { RawLocation, Route } from 'vue-router'

import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

import CustomerNotification from '@/models/customer-notification'

import EventBus from '@/event-bus'
import { AuthActionTypes } from '@/store/modules/auth/actions'
import {
  CustomerNotificationsGetters,
  CustomerNotificationsActionTypes,
} from '@/store/modules/customerNotifications'

@Component({
  components: {
    Footer,
    Header,
  },
  head: {
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  },
})
export default class AuthenticatedLayout extends Vue {
  beforeRouteUpdate(to: Route, from: Route, next: (to?: RawLocation) => void) {
    if (
      localStorage.getItem('logined') === 'true' &&
      this.$store.getters.isLogined
    ) {
      next()
    } else {
      this.onLogout()
    }
  }

  get customerName() {
    const customer = this.$store.getters.getCurrentCustomer
    return customer ? `${customer.firstName}` : ''
  }

  get notifications(): CustomerNotification[] {
    return this.$store.getters[
      CustomerNotificationsGetters.HeaderCustomerNotifications
    ]
  }

  get showFooter() {
    return !this.$route.matched.some((r) => r.meta && r.meta.hideFooter)
  }

  onLogout() {
    this.$store.dispatch(AuthActionTypes.Logout)
  }

  mounted() {
    EventBus.$on('dismissNotification', (id: number) => {
      this.$store.dispatch(CustomerNotificationsActionTypes.Dismiss, id)
    })

    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'logined' && event.newValue === 'false') {
        this.onLogout()
      }
    })

    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'refresh' && event.newValue?.match(/\d+/)) {
        const currentCustomerId = this.$store.getters.getCurrentCustomer.id

        if (event.newValue !== currentCustomerId.toString()) {
          this.$router.push({ name: 'dashboard' })
          this.$router.go(0)
        }
      }
    })
  }
}
